import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { Link } from 'react-router'
import classnames from 'classnames'

import WebsiteChooser from './WebsiteChooser'
import DropdownMenu from './DropdownMenu'
import Logout from '../auth/Logout'
import MenuWebsite from './MenuWebsite'
import MenuMain from './MenuMain'
import WelcomeActionBanner from './WelcomeActionBanner'
import Headway from './Headway'

@inject('auth')
@observer
export default class TopNav extends Component {
  shouldComponentUpdate() { return true }

  renderTrialBanner() {
    const { trial_info } = this.props.auth.user
    if (trial_info === null) return null

    function trial_days_left_string() {
      const plural = (trial_info.days_remaining != 1)
      return `${trial_info.days_remaining} day${plural ? 's' : ''}`
    }
    
    if (trial_info.has_subscribed) {
      return (
        <div className="trial-banner">
          Thank you for activating your Showcase IDX subscription! You have {trial_days_left_string()} remaining in your trial before billing begins.
        </div>
      )
    } else {
      if (trial_info.expired) {
        // NOTE: this actually never happes as we force-redirect to activation page in this case.
        return (
          <div className="trial-banner">
            Your trial has expired. <Link to="/billing">Activate your account now</Link>
          </div>
        )
      } else {
        return (
          <div className="trial-banner">
            You have {trial_days_left_string()} remaining in your trial. <Link to="/billing">Activate your account now</Link>
          </div>
        )
      }
    }
  }

  renderDunning() {
    const { license_needs_billing_update } = this.props.auth.user

    if (license_needs_billing_update) {
      return (
        <div className="trial-banner">
          Your account is past due. Please <Link to="/billing">Confirm Your Billing Details</Link>.
        </div>
      )
    }
  }

  render2to3Banner() {
    const { migration_status } = this.props.auth.user

    if (migration_status === 'migrated_undecided') {
      return (
        <div className="trial-banner">
          Your free upgrade period ends <strong>7/1/2018</strong> <Link to="/confirm-plan">Confirm Your Plan Now</Link>
        </div>
      )
    }
  }

  render() {
    const { auth, auth: { user, user: { impersonated, admin } }, website_id, websites: { current, loaded } } = this.props

    if (!user) return null

    return (
      <nav className={classnames('header', { impersonated })}>
        <div className="menu top">
          <Link to="/" className={classnames('logo', { active: !current })}/>

          {loaded &&
            <DropdownMenu menuClass="website" menuTitle={current ? current.name : 'Go To A Website...'}>
              <WebsiteChooser currentWebsite={current} />
            </DropdownMenu>}

          {this.renderTrialBanner()}
          {this.renderDunning()}
          {this.render2to3Banner()}

          <Headway />

          <DropdownMenu menuClass="user" menuTitle="My Account">
            <div className="user-info">
              <div className="label">Logged in as:</div>
              <div className="name">{user.name}</div>
            </div>
            <div className="separator"></div>
            { admin ? <Link to={`/users/${user.id}`}>Edit Account Details</Link> : '' }
            { admin && impersonated ? <Link to={`/agreements`}>Agreements</Link> : '' }
            <Logout logout={auth.logout.bind(auth)} />
          </DropdownMenu>
        </div>

        {(website_id && !loaded) ? <div /> : (current ? <MenuWebsite website={current} /> : <MenuMain />)}

        {(website_id && !loaded && current) ? <div/> : <WelcomeActionBanner />}
      </nav>
    )
  }
}



// WEBPACK FOOTER //
// client/components/navigation/TopNav.js